export const CLOSE = 'modal/CLOSE';
export const OPEN = 'modal/OPEN';
